import { CSSProperties, FC, useState } from 'react';
import { EmailInput } from '../../components/EmailInput';
import { AllieButton, AllieText } from '../../../components';
import { keyDownSubmit } from '../common/helpers';
import { LoginEmailFooter } from './LoginEmail.styles';

export interface LoginEmailProps {
  labelEmail: string;
  labelPassword: string;
  labelButton: string;
  labelForgotPassword: string;
  labelRememberUser?: string;
  autoFillCredentials?: boolean;
  getCredentials?: () => { email: string; password: string } | null;
  onAutoFillCredentials?: (shouldStoreUser: boolean) => void;
  onForgotPassword: (email?: string) => void;
  onCancel: () => void;
  onClose?: () => void;
  labelCancel: string;
  messageInvalidEmail: string;
  onSubmit: (email: string, password: string) => Promise<void>;
  style?: CSSProperties;
  errorMessage?: string;
  showError?: boolean;

}

export const LoginEmail: FC<LoginEmailProps> = ({
  onSubmit,
  labelButton,
  errorMessage,
  showError,
  style,
  onCancel,
  labelCancel,
  ...props
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleChangeEmail = (value: string, valid: boolean) => {
    setEmail(value);
    setIsEmailValid(valid);
  };

  const handleChangePassword = (pass: string) => {
    setPassword(pass);
  };

  const submit = async () => {
    setLoading(true);
    await onSubmit(email, password);
    setLoading(false);
  };

  const isDisabled = !isEmailValid || !email || !password;

  const onKeyDown = keyDownSubmit(isDisabled, submit);

  return (
    <div style={style} onKeyDown={onKeyDown as any}>
      <EmailInput
        {...props}
        onChangeEmail={handleChangeEmail}
        onChangePassword={handleChangePassword}
      />
      {showError && (
        <div style={{ marginTop: '12px' }}>
          <AllieText color='error-60'>{errorMessage}</AllieText>
        </div>
      )}
      <LoginEmailFooter>
        <AllieButton
          onclick={onCancel}
          allieSize="small"
          allieType="secondary"
          corner="rounded-edges"
        >
          {labelCancel}
        </AllieButton>
        <AllieButton
          tabIndex={1}
          onclick={submit}
          allieType="primary"
          allieSize="small"
          corner="rounded-edges"
          disabled={isDisabled}
          onKeyDown={onKeyDown}
          loading={loading}
        >
          {labelButton}
        </AllieButton>
      </LoginEmailFooter>
    </div>
  );
};
